import {
  buildIcsCalendar,
  instantDateKeyOf,
  pinOccurrenceToSingleEvent,
  type Anniversary,
  type EventException,
  type EventOccurrence,
  type ScheduleEvent,
} from "@couples/shared";

import { saveBlob } from "../media/export";

function saveIcsBlob(text: string, fileName: string): void {
  saveBlob(new Blob([text], { type: "text/calendar;charset=utf-8" }), fileName);
}

/**
 * カレンダー(予定+記念日+誕生日)を ICS ファイルとしてブラウザに保存させる。
 * サーバーには何も送らず、既に画面が持っているデータだけで組み立てる。
 * 戻り値は書き出した件数(呼び出し側のトースト表示用)。
 */
export function downloadScheduleIcs(
  events: readonly ScheduleEvent[],
  exceptions: readonly EventException[],
  anniversaries: readonly Anniversary[],
  categoryNameById: ReadonlyMap<string, string>,
): number {
  const text = buildIcsCalendar(events, exceptions, anniversaries, categoryNameById);
  saveIcsBlob(text, `saranosuke-calendar-${new Date().toISOString().slice(0, 10)}.ics`);
  return events.length + anniversaries.length;
}

/**
 * 予定1件だけを ICS にする(予定の詳細・編集シートから)。
 * 繰り返し予定はシリーズごと(RRULE・EXDATE込み)、「この回だけ」編集中は
 * その回だけを単発として書き出す(→ pinOccurrenceToSingleEvent)。
 */
export function downloadEventIcs(
  event: ScheduleEvent,
  exceptions: readonly EventException[],
  categoryNameById: ReadonlyMap<string, string>,
): void {
  const text = buildIcsCalendar([event], exceptions, [], categoryNameById);
  saveIcsBlob(text, `saranosuke-yotei-${instantDateKeyOf(event.startsAt)}.ics`);
}

/**
 * その日ぶんの予定だけを ICS にする(日別シートから)。
 * 繰り返し予定もその日の回だけの単発予定に固定して書き出す
 * (シリーズ全体はここでの関心ではないため)。
 * 戻り値は書き出した件数(呼び出し側のトースト表示用)。
 */
export function downloadDayIcs(
  dateKey: string,
  occurrences: readonly EventOccurrence[],
  categoryNameById: ReadonlyMap<string, string>,
): number {
  const events = occurrences.map((occurrence) => pinOccurrenceToSingleEvent(occurrence));
  const text = buildIcsCalendar(events, [], [], categoryNameById);
  saveIcsBlob(text, `saranosuke-yotei-${dateKey}.ics`);
  return events.length;
}
